import type { WorkspaceView } from "./workspace-navigation";

function key(userId: string, location: string) { return `workview:office-view:${userId}:${location}`; }
export function workspaceViewSearch(view: WorkspaceView) {
  const params = new URLSearchParams({ view: view.type });
  for (const [name, value] of Object.entries(view)) {
    if (name !== "type" && (typeof value === "string" || typeof value === "boolean")) params.set(name, String(value));
  }
  // Keep the existing shareable record-link parameter names.
  for (const [field, parameter] of [["customerId", "customer"], ["propertyId", "location"], ["jobId", "job"], ["invoiceId", "invoice"], ["estimateId", "estimate"]]) {
    const value = params.get(field);
    if (value) { params.delete(field); params.set(parameter, value); }
  }
  if (view.type === "job" && view.customerId) { params.delete("customer"); params.set("from", view.customerId); }
  return `?${params}`;
}
export function readWorkspaceViewState(userId: string | null, location: string): { search: string; focusDocumentId: string } | null {
  if (!userId) return null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key(userId, location)) ?? "null");
    if (!saved || typeof saved.search !== "string" || !saved.search.startsWith("?view=") || saved.search.length > 8000) return null;
    return { search: saved.search, focusDocumentId: typeof saved.focusDocumentId === "string" && saved.focusDocumentId.length < 256 ? saved.focusDocumentId : "" };
  } catch { return null; }
}
export function writeWorkspaceViewState(userId: string, location: string, view: WorkspaceView, focusDocumentId: string) {
  try { sessionStorage.setItem(key(userId, location), JSON.stringify({ search: workspaceViewSearch(view), focusDocumentId })); }
  catch { /* Restoring a tab is optional when browser storage is unavailable. */ }
}
